import { useEffect, useState } from "react";
import {
    Elements,
    PaymentElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import apiInstance from "../../apiInstance";
import Stripe from "../../../utility/stripe";
import Button from "../../Button";

const SetupForm = ({ closePopup, updateError }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        setLoading(true);

        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
            redirect: "if_required",
        });

        if (error) {
            updateError(error.message || 'Something went wrong, please try again later.');
        } else {
            closePopup();
        }

        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <div className="mjs-form-actions">
                {loading && (
                    <i
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                )}
                <button className="mjs-btn" disabled={!stripe || loading}>
                    {loading ? "Saving..." : "Save Card"}
                </button>
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </form>
    );
};

const AddPaymentMethod = ({ closePopup, updateError }) => {
    const [clientSecret, setClientSecret] = useState("");

    useEffect(() => {
        apiInstance
            .get("/dashboard/payment-method/setup-intent")
            .then((res) => setClientSecret(res.data.clientSecret));
    }, []);

    if (!clientSecret) return null;

    return (
        <Elements stripe={Stripe()} options={{ clientSecret }}>
            <SetupForm
                closePopup={closePopup}
                updateError={updateError}
            />
        </Elements>
    );
};

export default AddPaymentMethod;